<template>
  <custom-dialog :title="row ? `Edit asset` : `Create asset`">
    <template>
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-width="100px"
        v-if="row"
      >
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <div v-else>
        <el-upload
          action
          ref="upload"
          accept=".mp4, image/jpeg, image/png, image/gif, application/zip"
          drag
          multiple
          :show-file-list="false"
          :before-upload="beforeUploadFile"
          :http-request="uploadFile"
          :on-change="handleChange"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or
            <em>click to upload</em>
            <div>Tip:1.jpg/png/gif/mp4 files with a size less than 300mb</div>
            <div>2.zip files with a size less than 4mb</div>
          </div>
        </el-upload>
        <el-table :data="fileList">
          <el-table-column prop="name" label="Name"></el-table-column>
          <el-table-column prop="size" label="Size"></el-table-column>
          <el-table-column prop="status" label="Status">
            <template slot-scope="{ row }">
              <span v-show="!['ready', 'uploading'].includes(row.status)">{{
                row.status
              }}</span>
              <el-row
                type="flex"
                v-show="['ready', 'uploading'].includes(row.status)"
              >
                <el-col>
                  <el-progress :percentage="row.percentage"></el-progress>
                </el-col>
                <el-col :span="5">
                  <el-button class="btn btn-form pink" @click="abort(row)">
                    <i class="fas fa-times"></i>
                  </el-button>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template #footer-btn v-if="row">
      <el-button class="btn btn-form btn-blue btn-footer" @click="submit()"
        >Submit</el-button
      >
    </template>
  </custom-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CustomDialog from "@/components/base/customDialog";
export default {
  props: {
    row: Object,
    is_original: { type: Boolean, default: false },
  },
  data() {
    return {
      fileList: [],
      form: {},
      rules: {
        name: [
          {
            required: true,
            message: `Please input name`,
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {
    CustomDialog,
  },
  computed: {
    ...mapState({
      visible: (state) => state.isDialogVisible,
    }),
  },
  created() {
    this.initData();
  },
  watch: {
    visible(newVisible) {
      if (newVisible) this.initData();
    },
  },
  methods: {
    initData() {
      this.fileList = [];
      this.form = {
        name: "",
      };
      if (this.row) this.setData();
    },
    setData() {
      this.form = {
        name: this.row.name,
      };
    },
    async submit() {
      try {
        const valid = await this.$refs.ruleForm.validate();
        if (valid) {
          let setObj = {
            name: this.form.name,
          };

          if (this.row) {
            await store.dispatch("asset/updateAssetById", {
              id: this.row._id,
              setObj: setObj,
            });
          }
          this.$message({ message: "Success!", type: "success" });
          store.commit("setDialogVisible", false);
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeUploadFile(file) {
      // check file
      const is_type = [
        "video/mp4",
        "image/jpeg",
        "image/png",
        "image/gif",
        "application/zip",
        "application/x-zip-compressed",
        "application/zip-compressed",
      ].includes(file.type);
      const is_lt_300mb = file.size < 1024 * 1024 * 300;
      const is_lt_4mb = file.size < 1024 * 1024 * 4;
      if (!is_type)
        this.$message.error("Please upload jpg/png/gif/mp4/zip file.");
      if (!is_lt_300mb) this.$message.error("File size must be < 300mb.");
      if (
        file.type === "application/zip" ||
        file.type === "application/x-zip-compressed" ||
        file.type === "application/zip-compressed"
      ) {
        if (!is_lt_4mb) this.$message.error("File size must be < 4mb.");
        return is_type && is_lt_4mb;
      } else {
        return is_type && is_lt_300mb;
      }
    },
    uploadFile(option) {
      const { file } = option;
      const raw_file = _.find(
        this.fileList,
        (raw_file) => raw_file.uid === file.uid
      ).raw;
      const formData = new FormData();
      formData.append("file", raw_file);
      formData.append("is_original", this.is_original);
      const reader = new FileReader();
      reader.onload = async (event) => {
        const config = {
          onUploadProgress: (event) => {
            file.percent = (event.loaded / event.total).toFixed(2) * 100;
            option.onProgress(file);
          },
        };
        try {
          await store.dispatch("asset/createAsset", { formData, config });
          option.onSuccess();
        } catch (e) {
          option.onError();
        }
      };
      reader.readAsDataURL(file);
    },
    abort(file) {
      this.$refs.upload.abort(file);
      let fileList = this.$refs.upload.uploadFiles;
      fileList.splice(fileList.indexOf(file), 1);
      this.$refs.upload.onRemove(file, fileList);
    },
  },
};
</script>
